import type { LandingPageContent } from './types'

export const PHOTOVOLTAIK_ELEKTROINSTALLATION: LandingPageContent = {
  slug: 'photovoltaik-elektroinstallation',
  lang: 'de',
  topicId: 'photovoltaik-elektroinstallation',
  title: 'Photovoltaik-Elektroinstallation fachgerecht anschließen',
  metaDescription:
    'Module bereits montiert, Anschluss fehlt noch? Fragen Sie nur die Elektroinstallation an - ' +
    'Wechselrichter, Speicher, Zählertausch, Netzbetreiber-Anmeldung.',
  keywords: [
    'PV Anlage anschließen lassen',
    'Photovoltaik Elektroinstallation',
    'Wechselrichter installieren lassen',
    'Balkonkraftwerk anmelden Handwerker',
    'PV Anlage beim Netzbetreiber anmelden',
  ],
  eyebrow: 'Nur der elektrische Anschluss',
  h1: 'Photovoltaik-Anlage fachgerecht anschließen lassen',
  intro:
    'Module sind montiert, aber der elektrische Anschluss fehlt noch? Für den elektrischen Teil ' +
    'braucht es in Deutschland zwingend einen Elektrofachbetrieb - unter anderem für die Anmeldung ' +
    'beim Netzbetreiber. Bei Roofora können Sie diese Leistung als eigenen Auftragstyp anfragen, ganz ' +
    'ohne komplettes System.',
  sections: [
    { type: 'heading', text: 'Für wen sich eine reine Elektroinstallations-Anfrage lohnt' },
    {
      type: 'list',
      items: [
        'Die Module sind bereits montiert (z. B. durch Sie selbst oder einen anderen Betrieb) und es fehlt nur der elektrische Anschluss',
        'Sie möchten einen Batteriespeicher oder Wechselrichter nachrüsten',
        'Ein Zählertausch oder die Anmeldung beim Netzbetreiber steht noch aus',
      ],
    },
    { type: 'heading', text: 'Was zur Elektroinstallation dazugehören kann' },
    {
      type: 'list',
      items: [
        'Anschluss und Inbetriebnahme des Wechselrichters',
        'Nachrüstung eines Batteriespeichers in gewünschter Größe',
        'Zählerschrank-Anpassung bzw. Zählertausch',
        'Anmeldung und Inbetriebnahme bei Ihrem Netzbetreiber',
      ],
    },
    { type: 'heading', text: 'So läuft eine Elektroinstallations-Anfrage ab' },
    {
      type: 'paragraph',
      text:
        'Sie geben an, welche Hardware bereits vor Ort ist, ob Speicher oder Wechselrichter benötigt ' +
        'werden und ob ein Zählertausch ansteht. Handwerksbetriebe mit Elektrofachbetrieb-Qualifikation ' +
        'sehen Ihre anonymisierte Anfrage und geben unverbindliche Angebote nur für die ' +
        'Installationsleistung ab.',
    },
    { type: 'heading', text: 'Kontakt erst nach Ihrer Freigabe' },
    {
      type: 'paragraph',
      text:
        'Wie bei jedem Auftragstyp bei Roofora entsteht Kontakt erst, wenn Sie einen einzelnen Betrieb ' +
        'individuell freigeben - keine Sammelfreigabe, keine Anruf-Flut.',
    },
  ],
  faq: [
    {
      q: 'Muss die Elektroinstallation zwingend von einem Fachbetrieb übernommen werden?',
      a: 'Ja - der elektrische Anschluss und die Anmeldung beim Netzbetreiber müssen in Deutschland durch einen eingetragenen Elektrofachbetrieb erfolgen.',
    },
    {
      q: 'Kann ich auch nur einen Batteriespeicher nachrüsten lassen, ohne sonstige Arbeiten?',
      a: 'Ja - geben Sie bei der Anfrage einfach die gewünschte Speichergröße an, alle weiteren Angaben zur bestehenden Hardware sind optional.',
    },
    {
      q: 'Ich brauche nur einen neuen Wechselrichter, keine sonstigen Arbeiten - geht das?',
      a: 'Ja - "Ist bereits Hardware (Wechselrichter/Speicher) vorhanden?" ist ein optionales Feld bei der Anfrage. Geben Sie einfach an, dass ein Wechselrichter benötigt wird, den Rest der Angaben zur bestehenden Anlage können Sie offen lassen.',
    },
  ],
  primaryCta: { label: 'Elektroinstallation anfragen', action: 'customer' },
  secondaryCta: { label: 'Nur Dachmontage benötigt?', action: 'link', href: '/pv-module-montage' },
  relatedLinks: [
    { label: 'PV-Installateur finden', href: '/pv-installateur-finden' },
    { label: 'So funktioniert der Angebotsvergleich', href: '/pv-angebot-vergleichen' },
    { label: 'Photovoltaik Schritt für Schritt planen', href: '/photovoltaik-planen' },
    { label: 'Wallbox & Elektroauto mit PV-Überschuss laden', href: '/photovoltaik-wallbox-elektroauto' },
    { label: 'Anlage schon montiert - nur noch Abnahme & Anmeldung?', href: '/photovoltaik-abnahme-anmeldung' },
  ],
}
